import React from 'react';
import TextInput from '../TextInput/TextInput';
const parseNumber = (input = '', allowNegative = false) => input
    .replace(',', '.')
    .replace(/^\./g, '0.')
    .replace((allowNegative && /(?!^-)[^\d.]/g) || /[^\d.]/g, '')
    .replace(/^(.*?\..*?)\..*/g, '$1')
    .replace(/^0([\d].*)/g, '$1');
const NumberInput = ({ id, value = '', allowNegative = false, onChange, label, dataCy, }) => {
    var _a;
    return (React.createElement(TextInput, { id: id, value: ((_a = `${value}`) !== null && _a !== void 0 ? _a : '').replace('.', ','), onChange: (event) => onChange === null || onChange === void 0 ? void 0 : onChange(parseNumber(event.target.value, allowNegative)), label: label, dataCy: dataCy }));
};
export default NumberInput;
